import React, {FC} from 'react';

import {Trans} from '../../../../libs/shared/helpers/src/internationalization/react';
import {useToggle} from '../../../../libs/shared/helpers/src/react/hooks/hookHelpers';
import {EventHandler, Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownProps} from '../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {DropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {SimpleDropdown} from '../../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {CalendarVersionModel} from '../../../models/api/calendarVersionModel';
import {DropdownItemChevron} from '../../common/dropdowns/dropdownItemChevron';
import {EditCalendarDropdownContainer} from './editCalendarDropdownContainer';

/*
 * Props.
 */

interface CalendarsListItemDropdownProps extends DropdownProps {
  calendarVersion: CalendarVersionModel;
  onShowOnlyClick: Handler;
}

/*
 * Component.
 */

export const CalendarsListItemDropdown: FC<CalendarsListItemDropdownProps> = (props) => {
  const {calendarVersion, onShowOnlyClick, ...dropdownProps} = props;
  const {onRequestClose} = dropdownProps;
  const [isEditing, toggleIsEditing] = useToggle();

  const onEditClick: EventHandler = (event) => {
    event.preventDefault();
    toggleIsEditing();
  };

  if (isEditing) {
    return (
      <EditCalendarDropdownContainer
        {...dropdownProps}
        calendarVersion={calendarVersion}
        onBackButtonClick={toggleIsEditing}
        onRequestClose={onRequestClose}
      />
    );
  }

  return (
    <SimpleDropdown {...dropdownProps}>
      <DropdownItem onSelect={onShowOnlyClick} shouldReserveRightIcon>
        <DropdownItemContent>
          <Trans id="calendar-list-dropdown-showonly">Show this only</Trans>
        </DropdownItemContent>
      </DropdownItem>
      <DropdownItem onSelect={onEditClick} shouldReserveRightIcon>
        <DropdownItemContent>
          <Trans id="calendar-list-dropdown-edit-calendar">Edit calendar</Trans>
        </DropdownItemContent>
        <DropdownItemChevron />
      </DropdownItem>
    </SimpleDropdown>
  );
};
